import React, { useEffect, useState } from "react";
import api, { formatINR } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { BadgeCheck, X, Clock, Save, Trash2 } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function AdminDistributors() {
    const [items, setItems] = useState([]);
    const [editingDisc, setEditingDisc] = useState(null); // dist_id
    const [discPct, setDiscPct] = useState(0);

    const load = () => api.get("/admin/distributors").then(r => setItems(r.data));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.put(`/admin/distributors/${id}/status`, null, { params: { status } }); toast.success("Updated"); load(); }
        catch (e) { toast.error("Failed"); }
    };
    const saveDisc = async (id) => {
        try { await api.put(`/admin/distributors/${id}/discount`, null, { params: { discount_pct: discPct } }); toast.success("Saved"); setEditingDisc(null); load(); }
        catch (e) { toast.error("Failed"); }
    };
    const del = async (d) => {
        if (!window.confirm(`Permanently delete distributor "${d.business_name}"?\n\nThe linked user account stays — block them in Admin → Users if needed.`)) return;
        try { await api.delete(`/admin/distributors/${d.id}`); toast.success("Distributor deleted"); load(); }
        catch (e) { toast.error(e.response?.data?.detail || "Delete failed"); }
    };

    return (
        <div data-testid="admin-distributors">
            <Toaster position="top-center" />
            <div className="label-eyebrow text-sky-700">Wholesale partners</div>
            <h1 className="font-serif text-4xl text-stone-900 mt-2 mb-8">Distributors</h1>
            <div className="bg-white border border-stone-200">
                {items.map(d => (
                    <div key={d.id} className="border-b border-stone-100 last:border-b-0 p-4 grid grid-cols-12 gap-3 items-center" data-testid={`dist-row-${d.id}`}>
                        <div className="col-span-3"><div className="font-medium">{d.business_name}</div><div className="text-xs text-stone-500">{d.contact_name} · {d.email}</div></div>
                        <div className="col-span-2 text-xs">{d.phone}<br /><span className="text-stone-500">GSTIN: {d.gst_number || "—"}</span></div>
                        <div className="col-span-2 text-xs">{d.city}{d.state ? `, ${d.state}` : ""}<br /><span className="text-stone-500">{d.pincode}</span></div>
                        <div className="col-span-2">
                            {editingDisc === d.id ? (
                                <div className="flex gap-1">
                                    <Input type="number" value={discPct} onChange={(e) => setDiscPct(parseFloat(e.target.value || 0))} className="rounded-none border-stone-300 h-8" />
                                    <Button size="sm" onClick={() => saveDisc(d.id)} className="rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50"><Save className="w-3.5 h-3.5" /></Button>
                                </div>
                            ) : (
                                <button onClick={() => { setEditingDisc(d.id); setDiscPct(d.default_discount_pct); }} className="text-xs underline">{d.default_discount_pct}% disc</button>
                            )}
                        </div>
                        <div className="col-span-1">
                            <span className={`text-xs uppercase tracking-widest ${d.status === "approved" ? "text-sky-700" : d.status === "pending" ? "text-amber-700" : "text-red-700"}`}>{d.status}</span>
                        </div>
                        <div className="col-span-2 flex gap-1 justify-end">
                            {d.status !== "approved" && <Button size="sm" onClick={() => setStatus(d.id, "approved")} className="rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50" data-testid={`approve-dist-${d.id}`}><BadgeCheck className="w-3.5 h-3.5" /></Button>}
                            {d.status !== "suspended" && <Button size="sm" variant="outline" onClick={() => setStatus(d.id, "suspended")} className="rounded-none text-red-700 border-red-300" title="Suspend"><X className="w-3.5 h-3.5" /></Button>}
                            <button
                                onClick={() => del(d)}
                                className="text-red-600 hover:text-white hover:bg-red-600 border border-red-200 hover:border-red-600 px-2 py-1 transition-colors inline-flex items-center text-xs"
                                title="Permanently delete distributor profile"
                                data-testid={`dist-del-${d.id}`}
                            >
                                <Trash2 className="w-3.5 h-3.5" />
                            </button>
                        </div>
                    </div>
                ))}
                {items.length === 0 && <div className="p-8 text-center text-sm text-stone-500">No distributors yet.</div>}
            </div>
        </div>
    );
}
